<template>
  <div class="card mb-3">
    <div class="card-header">
      <span v-text="$ml.get('createPentest')">Vamos criar um pentest ?</span>
    </div>
    <div class="card-body col-24">
      <div class="d-flex justify-content-between col">
        <div class="col border-b">
          <div
            class="d-flex flex-column align-items-center p-2 box justify-content-center"
            @click="saveToLocalStorageAndNavigate('whitebox')"
          >
            <router-link tag="a" to="/create/pentest?target" class="link-block">
              <img src="../assets/images/pentest-white.png" />
            </router-link>
            <h6 class="mt-3">
              <a
                href="/create/pentest?target"
                v-text="$ml.get('whitebox')"
                class="link-block"
                >White Box</a
              >
            </h6>
            <p class="text-center d-flex" style="max-width: 368px">
              <a
                href="/create/pentest?target"
                v-text="$ml.get('descriptionWhiteBox')"
                class="link-block"
              ></a>
            </p>
          </div>
        </div>

        <div class="col border-b">
          <div
            class="d-flex flex-column align-items-center p-2 box justify-content-center"
            @click="saveToLocalStorageAndNavigate('blackbox')"
          >
            <router-link tag="a" to="/create/pentest?target" class="link-block">
              <img src="../assets/images/pentest-black.png" />
            </router-link>
            <h6 class="mt-3">
              <a
                href="/create/pentest?target"
                v-text="$ml.get('blackbox')"
                class="link-block"
                >Black Box</a
              >
            </h6>
            <p class="text-center d-flex" style="max-width: 368px">
              <a
                href="/create/pentest?target"
                v-text="$ml.get('descriptionBlackBox')"
                class="link-block"
              ></a>
            </p>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center p-2">
        <div class="col text-center">
          <p class="text-center m-0" v-if="totalWhiteBox == 0">
            <font v-text="$ml.get('dashMsgYouDHave')">Você não possui</font>&nbsp;<b
              v-text="$ml.get('none').toLowerCase()"
              >nenhum</b
            >&nbsp;<b v-text="$ml.get('whitebox')">White Box</b>!
          </p>
          <p class="text-center m-0" v-if="totalWhiteBox > 0">
            <font v-text="$ml.get('dashMsgYouHave')">Você possui</font>&nbsp;<b>
              <router-link to="/pentest"
                >{{ totalWhiteBox }}&nbsp;<font v-text="$ml.get('whitebox')"
                  >White Box</font
                >
              </router-link></b
            >
          </p>
        </div>
        <div class="col text-center">
          <p class="text-center m-0" v-if="totalBlackBox == 0">
            <font v-text="$ml.get('dashMsgYouDHave')">Você não possui</font>&nbsp;<b
              v-text="$ml.get('none').toLowerCase()"
              >nenhum</b
            >&nbsp;<b v-text="$ml.get('blackbox')">Black Box</b>!
          </p>
          <p class="text-center m-0" v-if="totalBlackBox > 0">
            <font v-text="$ml.get('dashMsgYouHave')">Você possui</font>&nbsp;<b>
              <router-link to="/pentest"
                >{{ totalBlackBox }}&nbsp;<font v-text="$ml.get('blackbox')"
                  >Black Box</font
                >
              </router-link></b
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CardCreatePentest",
  data() {
    return {
      totalWhiteBox: 0,
      totalBlackBox: 0,
    };
  },
  methods: {
    saveToLocalStorageAndNavigate(type) {
      localStorage.setItem("type_pentest", type);
    },
  },

  mounted() {
    const { blackbox, whitebox } = this.$store.getters["getAmount_pentests"];
    this.totalWhiteBox = whitebox;
    this.totalBlackBox = blackbox;
  },
};
</script>
<style scoped>
img {
  width: 120px;
}
.card-body {
  padding: 0px !important;
}
</style>
